export const EVENT_TYPE = {
  MEETING: 'Встреча',
  MASTER_KLASS: 'Мастер-класс',
  PRESENTATION_OF_PROJECTS: 'Презентация проектов',
  INTENSIVE: 'Интенсив',
};

export const EVENT_TITLE_DOD = {
  DOD_UX: 'День открытых дверей по UX/UI',
  DOD_JS: 'День открытых дверей по JavaScript',
  DOD_IST: 'День открытых дверей по JavaScript в Стамбуле',
  DOD_EVN: 'День открытых дверей по JavaScript в Ереване',
  DOD_SPEC: 'Специальное мероприятие',
  DOD_DS: 'День открытых дверей по Data Science',
  DOD_JS_START_CAREER: [
    'ДЕНЬ ОТКРЫТЫХ ДВЕРЕЙ «Как начать успешную карьеру в IT?»',
    'Презентация программы обучения веб-разработчиков',
  ],
  DOD_JS_PART_TIME: 'День открытых дверей по Part-time Bootcamp',
  DOD_OVER_FIFTY: 'Как сменить работу на IT-сферу в 50+ лет?',
};

export const EVENT_TITLE_MK = {
  MK_JS_BEGINNERS: 'JavaScript для начинающих',
  MK_JS_ADVANCED: 'JavaScript по решению задач',
  MK_DS_BEGINNERS: 'Python в Data Science для начинающих',
  MK_DS_ADVANCED: 'Python для продвинутых',
  MK_DS_TASKANALYSIS: 'Статистика для Data Science',
  MK_UX_BEGINNERS: 'Мастер-класс по UX/UI Design',
  MK_UX_ADVANCED: 'Мастер-класс по UX/UI Design для продвинутых',
};

export const EVENT_TITLE = {
  ...EVENT_TITLE_DOD,
  ...EVENT_TITLE_MK,
  PROJECTS_JS: 'Выпускной JavaScript Bootcamp', // TODO: remove when strapi events updated
  PROJECTS_JS_MSK: 'Выпускной JavaScript Bootcamp Москва',
  PROJECTS_JS_ONLINE: 'Выпускной JavaScript Online Bootcamp',
  PROJECTS_DS: 'Выпускной Data Science Bootcamp',
  INTENSIVE_JS: 'Мини-интенсив по JavaScript',
  INTENSIVE_DS: 'Мини-интенсив по Data Science',
  REMOTE_WORK: 'Удаленка: ожидание и реальность',
  BASIC_WEBDEV: 'Взломать гугл: основы веб-разработки',
  RELOCATION: 'Релокация без стресса',
  IT_GIRLS: 'Девушки в IT',
  QA_CEO_ELBRUS: 'Задай вопрос основателю Эльбруса',
  PRESENTATION_PROGRAM_UPDATES_JS:
    'Презентация обновлений программы веб-разработчик JavaScript',
  JOB_SEARCH: 'Митап "Как найти работу в IT в 2023 году?”',
};

export const EVENT_CITY = {
  ONLINE: 'Онлайн',
  MSK: 'Москва',
  MSK_ENG: 'Moscow',
  SPB: 'Санкт-Петербург',
  KZN: 'Казань',
  IST: 'Стамбул',
  EVN: 'Ереван',
};

export const EVENT_LOCATION = {
  ONLINE: 'Online',
  MSK: 'Кампус в Москве',
  MSK_ENG: 'Moscow campus',
  SPB: 'Кампус в Петербурге',
  KZN: 'Кампус в Казани',
  IST: 'Стамбул',
  EVN: 'Ереван',
};

export const FULL_EVENT_LOCATION = {
  ONLINE: 'Online',
  MSK: 'Москва, ул. Орджоникидзе, д.11 стр.10 (м. Ленинский проспект)',
  MSK_ENG: 'Moskva, ul. Ordzhonikidze, d.11 str.10 (m. Leninskij prospekt)',
  SPB: 'Лиговский проспект 140, БЦ Эко−Стандарт, 7 этаж (м. Обводный канал)',
  KZN: 'Казань, ул. Островского, 27, Коворкинг func',
};

export const EVENT_FILTERS = [
  { label: 'онлайн', value: 'online', isChosen: false },
  { label: 'офлайн', value: 'offline', isChosen: false },
  { label: 'мастер-классы', value: 'MASTER_KLASS', isChosen: false },
  { label: 'интенсив', value: 'INTENSIVE', isChosen: false },
  {
    label: 'встреча',
    value: 'MEETING',
    isChosen: false,
  },
  {
    label: 'презентация проектов',
    value: 'PRESENTATION_OF_PROJECTS',
    isChosen: false,
  },
];

export const EVENT_FORMAT_AMO = {
  MSK: 'офлайн МСК',
  MSK_ENG: 'офлайн МСК',
  SPB: 'офлайн СПБ',
  KZN: 'офлайн КЗН',
  ONLINE: 'онлайн',
  IST: 'офлайн',
  EVN: 'офлайн',
};

export const EVENT_FORMATS = {
  online: 'Онлайн',
  offline: 'Офлайн',
};

export const UX_EVENTS = ['DOD_UX', 'MK_UX_BEGINNERS', 'MK_UX_ADVANCED'];
